"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgBill(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M11 4h10c.579 0 1.32.21 1.73.586l9.631 8.828c.41.375.639 1.056.639 1.586v19c0 1.105-.795 2-2 2H11c-1.205 0-2-.895-2-2V6c0-1.105.795-2 2-2z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M22 5v9a1 1 0 001 1h10", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M14 29h14M14 24h14", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgBill;
//# sourceMappingURL=Bill.js.map